module.exports = __webpack_public_path__ + "static/media/feather.66cbb621.woff";